import React from 'react';
import TicketContent from './TicketContent';

export default function Tickets() {
  return <TicketContent />;
}
